import React, { useCallback, useEffect, useState } from 'react';
import { Toast } from './Toast';
import { emitToast, subscribeToast } from '../utils/toastBus';

const normalizeMessage = (message: unknown) => {
  if (typeof message === 'string') return message;
  if (message instanceof Error) return message.message || '알 수 없는 오류';
  if (message === null || typeof message === 'undefined') return '';
  return String(message);
};

export const GlobalToast: React.FC = () => {
  const [toastMessage, setToastMessage] = useState<string>('');
  const [toastDuration, setToastDuration] = useState<number>(1200);

  const handleClose = useCallback(() => {
    setToastMessage('');
  }, []);

  useEffect(() => {
    const unsubscribe = subscribeToast(({ message, duration }) => {
      setToastMessage(message);
      setToastDuration(typeof duration === 'number' ? duration : 1200);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const originalAlert = window.alert;
    window.alert = (message?: any) => {
      emitToast(normalizeMessage(message));
    };
    return () => {
      window.alert = originalAlert;
    };
  }, []);

  if (!toastMessage) return null;

  return <Toast message={toastMessage} duration={toastDuration} onClose={handleClose} />;
};
